import React, { Component } from 'react';
import { connect } from 'react-redux';
import Title from '../../helper/title';
import {reduxForm,Field,SubmissionError } from 'redux-form';
import M from 'materialize-css/dist/js/materialize.min.js'
import renderOption from '../../helper/option';
import renderInput from '../../helper/input';
import Modal from '../../helper/modal';
import {setAmount,setFee} from '../../../actions/ui/passport';
import {signNEO,signBTC,signETH,signLSK,signWAV} from '../../../actions/transfers/set';
import {payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT} from '../../../actions/transfers/set';
import {getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getLEMBFee,getUSDTFee} from '../../../actions/transfers/fees';
import TransferDetails from '../../helper/transferDetails';
import Circle from '../../helper/circle';
import $ from "jquery";
import {lowestDenom} from '../../../config';

class Transfers extends Component {
  renderModal(){
    let component = (<TransferDetails amount={this.props.amount} to={this.state.to} from={this.props.addressText} fee={this.props.fee} chain={this.props.view.toUpperCase()} />)
    let chain = this.props.view.toUpperCase() == 'EMB' || this.props.view.toUpperCase() == 'NRG' ? 'BSEC' : this.props.view.toUpperCase();
    return (
      <Modal id='modalTransfer' classes='modal modalOrders black-text' chain={chain} noClose={true} component={component} isOrder={false} decryption={true} buttonText={"Confirm"} buttonAction={this.submitOperation.bind(this)} />
    )
  }
  componentDidMount(){
    $('#to').focus();
    // var elems = document.querySelectorAll('.tooltipped');
    // var instances = M.Tooltip.init(elems,{});
  }
  componentWillReceiveProps(newProps){
    if(this.props.view != newProps.view){
      this.props[`get${newProps.view.replace('-','').toUpperCase()}Fee`](newProps.amount);
    }
  }
  constructor(){
    super();
    this.state = {view: 'nrg',view2:'nrg',to:''};
  }
  onChangeAmount(e){
    this.props.setAmount(e.target.value,()=>{});
    this.props[`get${this.props.view.toUpperCase()}Fee`](e.target.value);
  }
  changeAmount(percent){
    let newAmount = parseFloat(this.props.availableAmount * percent);
    this.props.setAmount(newAmount,()=>{})
    this.props[`get${this.props.view.toUpperCase()}Fee`](newAmount,()=>{});
  }
  changeAmount100(percent){
    let newAmount = parseFloat(this.props.availableAmount * percent);
    this.props[`get${this.props.view.toUpperCase()}Fee`](newAmount,()=>{
      let val = newAmount - this.props.fee
      $('#amount')[0].value = val;
      this.props.setAmount(val,()=>{})
    });
  }
  onChangeTo(e){
    this.setState({to:e.target.value});
  }
  submitOperation(){
    let password = $("#password").val();
    this.props[`pay${this.props.view.toUpperCase()}`]({password,amount:this.props.amount,to:this.state.to},(err,tx)=>{
      if(!err) {
        $('#amount')[0].value = '';
        $('#to')[0].value = '';
        $("#password")[0].value = '';
        this.props.setFee('',()=>{});
        this.props.setAmount('',()=>{})
        var instance = M.Modal.getInstance(document.querySelectorAll('#modalTransfer')[0]);
        if(instance) instance.close();
        setTimeout(()=>{
          M.toast({html: 'Transaction Submitted!',classes: "green",displayLength:3000});
        },200);
      }
      else {
        M.toast({html: err,classes:"red",displayLength:3000});
      }
    })
  }
  handleFormSubmit() {
    setTimeout(()=>{
      var instance = M.Modal.getInstance(document.querySelectorAll('#modalTransfer')[0]);
      instance.open();
      setTimeout(()=>{
        if($("#password")) $("#password").focus()
      },100)
    },100);
  }
  copyFrom(){
    var copyText = document.getElementById("from");

    var textField = document.createElement('textarea')
    textField.innerText =  copyText.value
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    M.toast({html: 'Copied Address',classes:"black",displayLength:3000});
  }
  renderForm(){
    const { handleSubmit } = this.props;
    let disabled = parseFloat(this.props.availableAmount) < parseFloat(this.props.amount)
    let label2 = `Tx Fee: ${this.props.fee} ${this.props.view.toUpperCase()}`;
    return (
      <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} style={{marginTop:'10px',zoom:1.1}} autoComplete='off'>
        <div className="row" style={{paddingTop:'5px'}}>
          <i className="material-icons searchIcon" onClick={this.copyFrom.bind(this)} style={{marginLeft:'-10px',marginTop:'32px',cursor:'pointer'}}>content_copy</i>
          <Field name="from" _id='from' onclick={this.copyFrom.bind(this)} component={renderInput} type="text" label={`From:`} disabled={true} val={this.props.addressText}  />
          <Field name="to" _id='to' onChang={this.onChangeTo.bind(this)} component={renderInput} step={'any'} type="text" label={`Recipient:`} required={true}/>
          <Field name="amount" _id='amount' onChang={this.onChangeAmount.bind(this)} component={renderInput} step={'any'} type="number" label={`Amount:`} label2={label2} required={true}/>
          {this.renderBalance()}
      </div>
        <div className="row center" style={{paddingTop:'10px'}}>
          <button className="btn black-text"  disabled={disabled} style={{backgroundColor:'white',fontSize:'15px'}} action="submit"> Send <b>{this.props.view}</b> <i className='material-icons' style={{float:'right',marginLeft:'5px'}}>send</i></button>
        </div>
      </form>
    )
  }
  renderBalance(){
    return (
      <div className='row' style={{paddingRight:'0.75em',paddingLeft:'0.75em',marginRight: "2px",marginLeft:'2px'}}>
        <div id='placeOrderBal' className='col s6' style={{padding:0}}>
          <p style={{margin:0}}>Balance: {this.props.availableAmount} {this.props.view.toUpperCase()}</p>
        </div>
        <div id='placeOrderNums' className='col s6' style={{padding:0,marginTop:'-2px'}}>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.1)}>10%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.25)}>25%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} onClick={this.changeAmount.bind(this,0.5)}>50%</p>
          </div>
          <div className='col s3'>
            <p style={{margin:0}} className='tooltipped' data-position="bottom" data-tooltip={`Full Balance - ${this.props.view.toUpperCase()} Tx Fee`} onClick={this.changeAmount100.bind(this,1)}>Max</p>
          </div>
        </div>
      </div>
    )
  }
  render() {
    let src = `/${this.props.view.toLowerCase()}.png`;

    let title = this.props.view;
    let address = this.props.view === 'nrg' ? 'emb' : this.props.view;
    let collateralized = this.props.view == 'nrg' ? `nrg_collateralized` : null;
    let leaseLocked = this.props.view == 'emb' ? 'my_emb_leased' :  null;

    return (
      <div className="col s12 transfers" style={{}}>
        <Title text='transfer' />

        <div className='col s3 center' style={{padding:'0',marginTop:'60px'}}>
          <h5 className='white-text' style={{fontFamily:'Gilmer'}}>{this.props.view.toUpperCase()}</h5>
          <Circle title={title} address={address} collateralized={collateralized} leaseLocked={leaseLocked} div='transferdiv' noLegend={true} big={true} />
        </div>

        <div className='col s6' style={{padding:'0'}}>
          {this.renderForm()}
          <br/>
        </div>

        <div className='col s3' style={{padding:'0',marginTop:'110px'}}>
        </div>
        {this.renderModal()}
      </div>

		)
  }
}

Transfers = reduxForm({
  form: 'transfers',  // name of the form
})(Transfers);

function mapStateToProps(state,props) {
  let curr = state.ui_passport.asset_view.toLowerCase();
  // console.log({curr})
  return {
    fee: state.passport.fee,
    amount: state.ui_passport.amount,
    view: state.ui_passport.asset_view,
    addressText: state.passport.wallet[curr].address,
    availableAmount: state.passport[state.ui_passport.asset_view] ? state.passport[state.ui_passport.asset_view] : 0,
  };
}


export default connect(mapStateToProps, {setAmount,
  setFee,signNEO,signBTC,signETH,signLSK,signWAV,
  getNEOFee,getBTCFee,getETHFee,getLSKFee,getWAVFee,getNRGFee,getEMBFee,getDAIFee,getLEMBFee,getUSDTFee,
  payNEO,payBTC,payETH,payLSK,payWAV,payNRG,payEMB,payDAI,payUSDT
})(Transfers);
